import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['CorrelationJob'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postCorrelationJobSubmit: build.mutation<PostCorrelationJobSubmitApiResponse, PostCorrelationJobSubmitApiArg>({
        query: (queryArg) => ({ url: `/CorrelationJob/submit`, method: 'POST', body: queryArg }),
        invalidatesTags: ['CorrelationJob'],
      }),
      getCorrelationJobById: build.query<GetCorrelationJobByIdApiResponse, GetCorrelationJobByIdApiArg>({
        query: (queryArg) => ({ url: `/CorrelationJob/${queryArg}` }),
        providesTags: ['CorrelationJob'],
      }),
      deleteCorrelationJobById: build.mutation<DeleteCorrelationJobByIdApiResponse, DeleteCorrelationJobByIdApiArg>({
        query: (queryArg) => ({ url: `/CorrelationJob/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['CorrelationJob'],
      }),
      getCorrelationJobGetAll: build.query<GetCorrelationJobGetAllApiResponse, GetCorrelationJobGetAllApiArg>({
        query: () => ({ url: `/CorrelationJob/get-all` }),
        providesTags: ['CorrelationJob'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as correlationJobApi };
export type PostCorrelationJobSubmitApiResponse = unknown;
export type PostCorrelationJobSubmitApiArg = ApiApplicationServicesDataTypesCorrelationTypesNewCorrelationJob;
export type GetCorrelationJobByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoCorrelationJobExternalDto;
export type GetCorrelationJobByIdApiArg = number;
export type DeleteCorrelationJobByIdApiResponse = unknown;
export type DeleteCorrelationJobByIdApiArg = number;
export type GetCorrelationJobGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoCorrelationJobExternalDto;
export type GetCorrelationJobGetAllApiArg = void;
export type ApiDatabaseCommonCorrelationJobType = 0 | 1;
export type ApiApplicationServicesDataTypesCorrelationTypesNewCorrelationJob = {
  name?: string | null;
  start?: string;
  end?: string;
  type?: ApiDatabaseCommonCorrelationJobType;
  measurementParameterIds?: number[] | null;
  measurementDeviceIds?: number[] | null;
  significanceThreshold?: number;
};
export type ApiDatabaseCommonCorrelationJobStatus = 0 | 1 | 2 | 3;
export type ApiCommonExternalDtoCorrelationJobExternalDto = {
  id?: number;
  name: string;
  start: string;
  end: string;
  creationDate: string;
  type: ApiDatabaseCommonCorrelationJobType;
  status: ApiDatabaseCommonCorrelationJobStatus;
  significanceThreshold: number;
  measurementDeviceIds: number[];
  measurementParameterIds: number[];
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoCorrelationJobExternalDto = {
  externalDto?: ApiCommonExternalDtoCorrelationJobExternalDto;
  externalDtos?: ApiCommonExternalDtoCorrelationJobExternalDto[] | null;
};
export const {
  usePostCorrelationJobSubmitMutation,
  useGetCorrelationJobByIdQuery,
  useLazyGetCorrelationJobByIdQuery,
  useDeleteCorrelationJobByIdMutation,
  useGetCorrelationJobGetAllQuery,
  useLazyGetCorrelationJobGetAllQuery,
} = injectedRtkApi;
